import React from 'react';
import './AtlasEmpty.css';

const AtlasEmpty = ({
  useDemo,
  onCreateRootFolder,
  title = 'No folders yet',
  body = 'Create folders to sketch the shape of this brain. Loose documents show up as Unfiled Documents until you drop them into a folder.',
  actionLabel = 'Create a folder',
  showAction,
}) => {
  const canCreate = showAction ?? !useDemo;
  return (
    <div className="atlas__empty">
      <div className="atlas__empty-title">{title}</div>
      <p className="atlas__empty-body">{body}</p>
      <div className="atlas__empty-actions">
        {canCreate && (
          <button type="button" className="atlas__toolbar-btn" onClick={onCreateRootFolder}>
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default AtlasEmpty;
